module.exports = __webpack_public_path__ + "img/lasource-14.f10db39d.jpg";